import { render, staticRenderFns } from "./MarketplaceSubscriptions.vue?vue&type=template&id=c31c1376&"
import script from "./MarketplaceSubscriptions.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports